<nz-card nzTitle="Equipment Details">
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="(loading$ | async) ?? false"
    [nzParagraph]="{ rows: 8 }"
  >
    <ng-container *ngIf="errorMessage$ | async as errorMsg; else result">
      <em-error-result [subTitle]="errorMsg"></em-error-result>
    </ng-container>
  </nz-skeleton>
</nz-card>

<ng-template #result>
  <ng-container *ngIf="equipmentDetails$ | async as equipment; else noData">
    <nz-row>
      <nz-descriptions nzTitle="General" [style.margin-bottom]="'15px'" nzLayout="vertical">
        <nz-descriptions-item nzTitle="Price">
          <em-display-property
            [value]="price"
            [templateIsEmpty]="!equipment.aquisitionValue"
          ></em-display-property>
          <ng-template #price>
            {{ equipment.aquisitionValue }} {{ equipment.currencyKey }}
          </ng-template>
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-row>
    <nz-row>
      <nz-descriptions nzTitle="Mould" [style.margin-bottom]="'15px'" nzLayout="vertical">
        <nz-descriptions-item nzTitle="Status">
          <em-display-property [value]="equipment.statusCode | trimZeroes"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Cleaning Interval">
          <em-display-property
            [value]="equipment.cleaningInterval | trimZeroes"
          ></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Last Cleaning">
          <em-display-property [value]="equipment.lastCleaning | trimZeroes"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Budget Shots">
          <em-display-property [value]="equipment.budgetShots | trimZeroes"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Mould Budget Year">
          <em-display-property [value]="equipment.mouldBudgetYear"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Mould Box Included in Price">
          <em-display-property [value]="equipment.mouldBoxInclInPrice"></em-display-property>
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-row>
    <nz-row></nz-row>
    <nz-row>
      <nz-col nzSpan="8">
        <em-mould-developers></em-mould-developers>
      </nz-col>
      <nz-col nzSpan="16">
        <nz-descriptions
          nzTitle="Organization"
          [style.margin-bottom]="'15px'"
          nzLayout="vertical"
          [nzColumn]="2"
        >
          <nz-descriptions-item nzTitle="WBS Element">
            <em-display-property [value]="equipment.wbsElement"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Settlement Order">
            <em-display-property [value]="equipment.settlementOrder"></em-display-property>
          </nz-descriptions-item>
        </nz-descriptions>
      </nz-col>
    </nz-row>
  </ng-container>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>
